(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["column-images-grid-new"] && !Shopify.designMode) return;
  try {
    
  class ColumnImagesGridNew extends HTMLElement {
    constructor() {
      super();
      this.flickityInstance = null;
      this.resizeTimeout = null;
    }

    connectedCallback() {
      this.initWhenReady();
    }

    disconnectedCallback() {
      this.destroySlider();
      window.removeEventListener('resize', this._resizeHandler, false);
    }

    initWhenReady() {
      if (typeof window.theme === 'undefined' || typeof window.theme.Slideshow === 'undefined') {
        setTimeout(() => this.initWhenReady(), 50);
        return;
      }
      this.initSlider();
      this._resizeHandler = () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.initSlider();
          this.updateImageSizes();
        }, 250);
      };
      window.addEventListener('resize', this._resizeHandler, false);
      this.updateImageSizes();
    }

    initSlider() {
      const isMobile = window.innerWidth < 769;
      const itemsPerRowMobile = parseInt(
        this.querySelector('.column-images-grid-new__items')?.getAttribute('data-items-per-row-mobile') || '2',
        10
      );

      if (isMobile) {
        if (!this.flickityInstance) {
          this.flickityInstance = new window.theme.Slideshow(this.querySelector('.column-images-grid-new__items'), {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: true,
            wrapAround: false,
            groupCells: itemsPerRowMobile,
          });

        }
      } else {
        this.destroySlider();
      }
    }

    destroySlider() {
      if (this.flickityInstance && typeof this.flickityInstance.destroy === 'function') {
        this.flickityInstance.destroy();
      }
      this.flickityInstance = null;
    }

    updateImageSizes() {
      const images = this.querySelectorAll('.column-images-grid-new__image img');
      const isMobile = window.innerWidth < 769;
      images.forEach((img) => {
        const mobileWidth = img.dataset.mobileWidth || '56';
        const desktopWidth = img.dataset.desktopWidth || '56';
        const width = isMobile ? mobileWidth : desktopWidth;
        img.style.maxWidth = width + 'px';
        img.style.maxHeight = width + 'px';
      });
    }
  }

  if (!window.customElements.get('column-images-grid-new')) {
    window.customElements.define('column-images-grid-new', ColumnImagesGridNew);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-reseller"] && !Shopify.designMode) return;
  try {
    
  class SkuSearch extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('[data-search-form]');
      this.input = this.querySelector('[data-search-input]');
      this.submit = this.querySelector('[data-search-submit]');
      this.errorInvalidFormat = this.querySelector('[data-error-invalid-format]');
      this.errorNoResults = this.querySelector('[data-error-no-results]');

      this.skuPattern = /^[A-Z]{2}\d[A-Z]{2}\d{3}$/;
      this.isSearching = false;

      this.translations = {
        searching: this.dataset.searching,
        submitText: this.dataset.submitText,
      };

      this.init();
    }

    init() {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      this.input.addEventListener('input', this.handleInput.bind(this));
      this.input.addEventListener('keyup', this.formatInput.bind(this));
    }

    handleInput(e) {
      this.hideErrors();
      this.updateSubmitState();
    }

    formatInput(e) {
      let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');

      if (value.length > 8) {
        value = value.substring(0, 8);
      }

      e.target.value = value;
      this.updateSubmitState();
    }

    updateSubmitState() {
      const isValid = this.isValidSku(this.input.value);

      if (isValid) {
        this.input.classList.remove('error');
      }
    }

    isValidSku(sku) {
      return this.skuPattern.test(sku);
    }

    async handleSubmit(e) {
      e.preventDefault();

      const sku = this.input.value.trim();

      if (!this.isValidSku(sku)) {
        this.showInvalidFormatError();
        this.input.classList.add('error');
        return;
      }

      this.setLoading(true);

      try {
        const results = await this.searchBySku(sku);

        if (results && results.length > 0) {
          if (results.length === 1) {
            window.location.href = results[0].url;
          } else {
            window.location.href = `/search?q=${encodeURIComponent(sku)}`;
          }
        } else {
          this.showNoResultsError();
        }
      } catch (error) {
        console.error('Search error:', error);
        this.showNoResultsError();
      } finally {
        this.setLoading(false);
      }
    }

    async searchBySku(sku) {
      const searchUrl = `${window.Shopify.routes.root}search`;
      const params = new URLSearchParams({
        q: sku,
      });

      const response = await fetch(`${searchUrl}?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'text/html',
        },
      });

      if (!response.ok) {
        throw new Error('Search request failed');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const collectionWrapper = doc.querySelector('.collection-grid__wrapper');
      if (!collectionWrapper) {
        return [];
      }

      const firstProductLink = collectionWrapper.querySelector('.grid-product__link');
      if (!firstProductLink) {
        return [];
      }

      const href = firstProductLink.getAttribute('href');
      if (!href) {
        return [];
      }

      return [{ url: href }];
    }

    setLoading(loading) {
      this.isSearching = loading;
      this.classList.toggle('hero-reseller--loading', loading);
      this.submit.disabled = loading;

      if (loading) {
        this.submit.querySelector('.hero-reseller__submit-text').textContent = this.translations.searching;
      } else {
        this.submit.querySelector('.hero-reseller__submit-text').textContent = this.translations.submitText;
      }
    }

    showInvalidFormatError() {
      this.hideErrors();
      this.errorInvalidFormat.classList.remove('hidden');
      this.classList.add('hero-reseller--error');
    }

    showNoResultsError() {
      this.hideErrors();
      this.errorNoResults.classList.remove('hidden');
      this.classList.add('hero-reseller--error');
    }

    hideErrors() {
      this.errorInvalidFormat.classList.add('hidden');
      this.errorNoResults.classList.add('hidden');
      this.classList.remove('hero-reseller--error');
    }
  }

  customElements.define('sku-search', SkuSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-banner"] && !Shopify.designMode) return;
  try {
    
  class VideoLazy extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template');
      this.overlay = this.querySelector('.video-overlay');
      this.playButton = this.querySelector('.video-play-btn');
      this.videoContainer = null;
      this.isVideoReady = false;
      this.isLoading = false;
      this.pendingPlay = false;

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.playButton.addEventListener('click', () => {
        if (this.isLoading) return;
        this.handlePlay();
      });
    }

    setLoading(loading) {
      this.isLoading = loading;
      this.playButton.classList.toggle('loading', loading);
      this.playButton.disabled = loading;
    }

    handlePlay() {
      if (!this.videoContainer) {
        this.setLoading(true);
        this.pendingPlay = true;

        const content = this.template.content.cloneNode(true);
        this.videoContainer = content.querySelector('video');
        this.appendChild(this.videoContainer);
        this.setupHTML5Video();
      } else if (this.isVideoReady) {
        this.playVideo();
      } else {
        this.pendingPlay = true;
      }
    }

    setupHTML5Video() {
      const video = this.videoContainer;

      video.addEventListener('loadeddata', () => {
        this.isVideoReady = true;
        this.setLoading(false);
        if (this.pendingPlay) {
          this.pendingPlay = false;
          this.playVideo();
        }
      });

      video.addEventListener('play', () => {
        this.overlay.classList.add('hidden');
      });

      video.addEventListener('pause', () => {
        this.overlay.classList.remove('hidden');
      });

      video.addEventListener('ended', () => {
        this.overlay.classList.remove('hidden');
      });

      video.load();
    }

    playVideo() {
      if (!this.isVideoReady) {
        this.pendingPlay = true;
        return;
      }

      try {
        const playPromise = this.videoContainer.play();
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.error('Error playing video:', error);
            this.setLoading(false);
          });
        }
      } catch (error) {
        console.error('Error playing video:', error);
        this.setLoading(false);
      }
    }

    disconnectedCallback() {
      if (this.videoContainer) {
        this.videoContainer.removeEventListener('loadeddata', null);
        this.videoContainer.removeEventListener('play', null);
        this.videoContainer.removeEventListener('pause', null);
        this.videoContainer.removeEventListener('ended', null);
      }
    }
  }

  customElements.define('video-lazy', VideoLazy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text-new"] && !Shopify.designMode) return;
  try {
    
  class VideoLazy extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template');
      this.overlay = this.querySelector('.video-overlay');
      this.playButton = this.querySelector('.video-play-btn');
      this.videoContainer = null;
      this.isVideoReady = false;
      this.isLoading = false;
      this.pendingPlay = false;

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.playButton.addEventListener('click', () => {
        if (this.isLoading) return;
        this.handlePlay();
      });
    }

    setLoading(loading) {
      this.isLoading = loading;
      this.playButton.classList.toggle('loading', loading);
      this.playButton.disabled = loading;
    }

    handlePlay() {
      if (!this.videoContainer) {
        this.setLoading(true);
        this.pendingPlay = true;

        const content = this.template.content.cloneNode(true);
        this.videoContainer = content.querySelector('video');
        this.appendChild(this.videoContainer);
        this.setupHTML5Video();
      } else if (this.isVideoReady) {
        this.playVideo();
      } else {
        this.pendingPlay = true;
      }
    }

    setupHTML5Video() {
      const video = this.videoContainer;

      video.addEventListener('loadeddata', () => {
        this.isVideoReady = true;
        this.setLoading(false);
        if (this.pendingPlay) {
          this.pendingPlay = false;
          this.playVideo();
        }
      });

      video.addEventListener('play', () => {
        this.overlay.classList.add('hidden');
      });

      video.addEventListener('pause', () => {
        this.overlay.classList.remove('hidden');
      });

      video.addEventListener('ended', () => {
        this.overlay.classList.remove('hidden');
      });

      video.load();
    }

    playVideo() {
      if (!this.isVideoReady) {
        this.pendingPlay = true;
        return;
      }

      try {
        const playPromise = this.videoContainer.play();
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.error('Error playing video:', error);
            this.setLoading(false);
          });
        }
      } catch (error) {
        console.error('Error playing video:', error);
        this.setLoading(false);
      }
    }

    disconnectedCallback() {
      if (this.videoContainer) {
        this.videoContainer.removeEventListener('loadeddata', null);
        this.videoContainer.removeEventListener('play', null);
        this.videoContainer.removeEventListener('pause', null);
        this.videoContainer.removeEventListener('ended', null);
      }
    }
  }

  customElements.define('video-lazy', VideoLazy);

  } catch(e) { console.error(e); }
})();
})();
